import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';

export const WrapperStepper = styled(Box)(({ theme }) => ({
  marginBottom: '45px',
  [theme.breakpoints.down('md')]: {
    marginBottom: '24px'
  }
}));

export const CardGridStyled = styled(Box)(() => ({
  marginBottom: '24px'
}));

export const LinkStyled = styled(Link)(() => ({
  textDecoration: 'none'
}));

export const ActionsRoot = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.neutrals.beige2,
    margin: 0,
    alignItems: 'center',
    padding: ` ${theme.spacing(2)} ${theme.spacing(3)}`
  }
}));

export const TriagemCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.colored_variation.lightGreenPastel,
  borderRadius: '16px',
  padding: '20px',
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  gap: '20px',
  marginBottom: '24px',
  [theme.breakpoints.down('md')]: {
    alignItems: 'center'
  }
}));

export const TriagemActionButton = styled(Button)(() => ({
  height: '48px',
  padding: '12px 24px'
}));
